import {makeFileUploadBody, post} from '../utils'

export default host => (clientId, imageFile) => 
  post(`${host}/clients/${clientId}/image`, makeFileUploadBody('image', imageFile)).then(response => response.json())
